// extracted by mini-css-extract-plugin
export default {"alert-icon":"styles_alert-icon__Or8lt","alert-icon__text":"styles_alert-icon__text__t9ke8"};